import React, { useState, useRef } from 'react';
import { View, TextInput, Pressable } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { StyleSheet, useUnistyles } from 'react-native-unistyles';

let search_timeout = null;

const SearchBox = ({ref, ...props}) => {
    const { searchText, placeholder, onEndEditing, onChangeText, onFocus, onBlur, textChangeDelay = 500, nobackground = false, isNotOnSurface = true, focusRefOnArrowKey, testID } = props;

    const [searchKey, setSearchKey] = useState(0);
    const defaultRef = useRef(null);
    const search_ref = ref || defaultRef;
    
    const { theme: { colors }, rt: { themeName } } = useUnistyles();

    const closeButton = searchText && searchText.length > 0 ? <Pressable hitSlop={20} onPress={() => {
        setSearchKey(searchKey + 1);
        onChangeText("")
        setTimeout(() => search_ref.current?.focus(), 100)
    }} style={styles.closeButton}><Unicon name="close" colorVariant="textSecondary" size={18} /></Pressable> : <View></View>

    return(
        <View style={styles.container}>
            <View style={styles.searchIcon}><Unicon name="search-outline" colorVariant="textSecondary" size={18} /></View> 
            {closeButton}

            <TextInput
                testID={"SearchBox-" + (testID ?? "")}
                key={searchKey}
                onKeyPress={(e) => {
                    if(e.key === "ArrowDown"){
                        search_ref.current?.blur();

                        if(focusRefOnArrowKey){
                            focusRefOnArrowKey.current?.focus();
                        }
                    }
                }}
                returnKeyType="search"
                ref={search_ref}
                keyboardAppearance={themeName}
                autoCorrect={false}
                style={styles.input(nobackground, isNotOnSurface)}
                defaultValue={searchText} 
                placeholder={placeholder || "Search" } 
                placeholderTextColor={colors.textSecondary}
                onFocus={onFocus}
                onBlur={onBlur}
                onChangeText={(text) => {
                    if(onChangeText){
                        clearTimeout(search_timeout);
                        search_timeout = setTimeout(() => {
                            onChangeText(text);
                        }, textChangeDelay);
                    }
                }}
                onEndEditing={(e) => {
                    if(onEndEditing){
                        onEndEditing(e);
                    }
                }}
            />
        </View>
    )
}

const styles = StyleSheet.create(({colors, fonts, shadows, roundness}, rt) => ({
    container: {
        position: "relative",
        height: Math.max(44, Math.ceil(44 * rt.fontScale)),
    },
    input: (nobackground, isNotOnSurface) => ({
        flex: 1,
        outlineStyle: 'none',
        backgroundColor: nobackground ? "transparent" : (isNotOnSurface ? colors.surface : colors.inputBackground),
        boxShadow: nobackground ? shadows.none : (isNotOnSurface ? shadows.card : shadows.none),
        paddingLeft: 44,
        paddingRight: 40,
        color: colors.text,
        fontSize: 14,
        fontFamily: fonts.body,
        borderRadius: roundness.sm,
        zIndex: 1,
        includeFontPadding: false,
        textAlignVertical: 'center',
        _web: {
            transition: "all 0.15s ease",
            _focus: {
                boxShadow: nobackground ? shadows.none : shadows.input,
            },
            _hover: {
                backgroundColor: nobackground ? "transparent" : colors.hover,
            }
        }
    }),
    closeButton: {
        position: "absolute",
        top: Math.max(13, Math.ceil((44 * rt.fontScale - 18) / 2)),
        right: 14,
        zIndex: 5,
    },
    searchIcon: {
        position: "absolute",
        top: Math.max(13, Math.ceil((44 * rt.fontScale - 18) / 2)),
        left: 14,
        zIndex: 2,
    }
}))

export default SearchBox